<template>
  <div class="segment-remove">
    <img :src="require('@/assets/svg/SVG/remove_btn.svg')" />
  </div>
</template>

<script>
export default {
  name: 'SegmentRemove'
};
</script>

<style scoped>
.segment-remove {
  color: white;
  cursor: pointer;
  margin-bottom: auto;
  width: 18px;
  display: flex;
  align-content: center;
  justify-content: center;
}
</style>